import { render, staticRenderFns } from "./instractions.vue?vue&type=template&id=6927733a&scoped=true"
import script from "./instractions.vue?vue&type=script&lang=js"
export * from "./instractions.vue?vue&type=script&lang=js"
import style0 from "./instractions.vue?vue&type=style&index=0&id=6927733a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6927733a",
  null
  
)

export default component.exports